import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './LoadingModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import Spinner from "react-bootstrap/Spinner";
const LoadingModal = ({ showLoadingModal, setShowLoadingModal }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowLoadingModal(false)
  }

  useEffect(() => {
    // let msisdn = null;

    // if (playerData?.id) {
    //   msisdn = playerData?.msisdn;
    // }
    // activityLogSubmission("contacts", msisdn);
    // analyticEvent('contact', 'contact-view')
  }, [])


  return (
    <>
      <Modal show={showLoadingModal} centered dialogClassName="modal-dialog" contentClassName="modalContent" onHide={hideModalOperation}>
        <Modal.Header >
          <Modal.Title>Loading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Spinner animation="border" className='loadingSpinner' />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default LoadingModal